import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Categories from "./components/Categories";
import UpdateZone from "./components/UpdateZone";
import BingeZone from "./components/BingeZone";
import Features from "./components/Features";
import FAQ from "./components/FAQ";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import { faqs } from "@/mocks/anime";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <Categories />
        <UpdateZone />
        <BingeZone />
        <Features />
        <FAQ />
        <About />
        <Newsletter />
      </main>
      <Footer />

      {showTop && (
        <a
          href="#home"
          className="fixed bottom-6 right-6 z-40 grid h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lift transition-colors hover:bg-primary-600"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-xl" />
        </a>
      )}
    </>
  );
}